import React, { PureComponent } from 'react'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import namedays from '../../static/namedays'
import './menuNamedays.pcss'

export default class MenuNamedays extends PureComponent {
  render() {
    const timestamp = moment(this.props.timestamp)
    const namesFull = namedays.get(timestamp.format('DDMM'))
    const namesShort = namesFull.split(' ').slice(0, 3).join(' ').replace(/,$/g, '…')
    const today = timestamp.format('dd D.M.')
    const todayCapitalized = today.charAt(0).toUpperCase() + today.slice(1)

    return (
      <div className='menu-namedays'>
        <span className='menu-namedays__date'>{ todayCapitalized }</span>
        <span className='menu-namedays__names' title={ namesFull }>{ namesShort }</span>
      </div>
    )
  }
}

MenuNamedays.propTypes = exact({
  timestamp: PropTypes.number.isRequired,
})
